import { createContext } from "react";
import swal from "sweetalert";
import moment from "moment";
// export const apiUrl = "http://192.168.2.82:8081"
//  export const baseUrl = "http://192.168.2.82:8081/"
// export const apiUrl = "http://104.236.9.55:6005"
// export const baseUrl = "http://104.236.9.55:6005/"
// export const socketUrl = "ws://104.236.9.55:6005/boot-stomp"
export const weburl = "https://staging-cultivator.semilla.app/"
export const apiUrl = "https://semilla-api.netsetsoftware.pro"
export const baseUrl = "https://semilla-api.netsetsoftware.pro/"
export const socketUrl = "wss://semilla-api.netsetsoftware.pro/boot-stomp"

// export const weburl = "https://cultivator.semilla.app/"
//  export const apiUrl = "https://api.semilla.app"
//  export const baseUrl = "https://api.semilla.app/"
//  export const socketUrl = "wss://api.semilla.app/boot-stomp"
 export const allowedImageTypes = ['image/jpeg', 'image/png','image/jpg'];
 export const allowedDocTypes = ['application/pdf', 'text/csv','application/vnd.openxmlformats-officedocument.wordprocessingml.document',"application/vnd.oasis.opendocument.text","text/plain"];
 export const EMAILREGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

 export const gKey = "AIzaSyA8FESApdFqas53CJfQQ1CP28PsKTPB1tQ"
 export const MyContext = createContext();
 export const UtctolocalDate=(dateTime)=>{
  return moment.utc(dateTime).local()

}
export const errorHandling=(code)=>{
    if(code === 401 || code === 403) {
    swal({ icon: 'error', text: "Your session has been expired, please login again. ", button: "OK" }).then(() => {
        localStorage.clear()
        window.location.href = "/login"   
      });
    }
}
export const  dateFormate = 'DD/MM/YYYY hh:mm A'
export const PasswordRegex =/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const getStatus = (Otderstatus)=>{
  let status = ""
  if(Otderstatus=="ORDER_INITIATED"){
    status = "Pending"
}else if(Otderstatus=="ORDER_REJECTED"){
    status = "Rejected"

}else if(Otderstatus=="PICKUP_CONFIRMATION_PENDING"){
    status = "Driver Not Assigned"

} else if(Otderstatus=="SEARCHING_DELIVERY_PARTNER"){
    status = "Driver Not Assigned"

}else if(Otderstatus=="PICKUP_CONFIRM"){
    status = "Driver Assigned"

}else if(Otderstatus=="OUT_FOR_DELIVERY"){
    status = "Out For Delivery"

}else if(Otderstatus=="ORDER_CANCELLED"){
    status = "Order Cancelled"

}else if(Otderstatus=="ORDER_DELIVERED"){
    status = "Order Delivered"

}else if(Otderstatus=="PICKUP_REJECTED"){
    status = "Pickup Rejected"

}else if(Otderstatus=="PICKUP_PARTNER_VERIFIED"){
    status = "Out for Delivery"

}else if(Otderstatus=="AT_DELIVERY_LOCATION"){
    status = "Driver Arriving Shortly"

}else
{
    status = Otderstatus
}

return status
}


export let FilterStatus =[
    {
      label:"Pending" ,
      value: "ORDER_INITIATED"
    },
    {
        label:"Rejected" ,
        value: "ORDER_REJECTED"
      },
      {
        label:"Cancelled" ,
        value: "ORDER_CANCELLED"
      },
      {
        label:"Out For Delivery" ,
        value: "OUT_FOR_DELIVERY"
      },
      {
        label:"Driver Not Assigned" ,
        value: "PICKUP_CONFIRMATION_PENDING"
      },
      {
        label:"Delivered" ,
        value: "ORDER_DELIVERED"
      },
   
      // {
      //   label:"Driver Assigned" ,
      //   value: "PICKUP_CONFIRM"
      // }
      
]
 	
// public static final String REJECTED = "ORDER_REJECTED";
// public static final String CONFIRMED = "CONFIRMED";
// public static final String SEARCHING_DELIVERY_PARTNER = "SEARCHING_DELIVERY_PARTNER";
// public static final String PICKUP_CONFIRMATION_PENDING = "PICKUP_CONFIRMATION_PENDING";
// public static final String PICKUP_REJECTED = "PICKUP_REJECTED";
// public static final String PICKUP_CONFIRM = "PICKUP_CONFIRM";
// public static final String PICKUP_PARTNER_VERIFIED = "PICKUP_PARTNER_VERIFIED";
// public static final String OUT_FOR_DELIVERY = "OUT_FOR_DELIVERY";
// public static final String AT_DELIVERY_LOCATION = "AT_DELIVERY_LOCATION";
// public static final String DELIVERED = "ORDER_DELIVERED";
// public static final String CANCELLED = "ORDER_CANCELLED";